import {railStates} from './../../../ukrail/ukrail-routes';

export default function UkRailRoundtripBaseController(
    $scope,
    $state,
    $timeout,
    $window,
    $filter,
    $stateParams,
    railsFactory,
    railsUtils,
    userService,
    l10nService,
    timeService,
    moment,
) {
    'ngInject';

    railsFactory.resetSegmentFilterData();

    const previousSearches = getPreviousSearchObject();

    init();

    function init() {
        const {DomesticSearchGUId} = $stateParams;
        if (DomesticSearchGUId && +DomesticSearchGUId !== 0) {
            performDomesticSearch();
        }
    }
    $scope.moment = moment;
    $scope.flightType = 'roundtrip';
    $scope.showOptions = railsFactory.showOptions;
	$scope.previousSearches = [];
    $scope.maxPreviousSearches = railsFactory.TOP_PREV_SEARCHES_LIMIT;
    $scope.updateArrival = function(segmentIndex, isArrival) {
        $scope.params.RailTicketSearchSegments[segmentIndex]._isArrivalTime = isArrival;
    };
    $scope.updateArrivalOneWay = function(index, value) {
        $scope.params.RailTicketSearchSegments[index]._isArrivalTime = value;
    };
    $scope.allPreviousResultsShown = allPreviousResultsShown;
    $scope.togglePreviousSearches = togglePreviousSearches;

    setJourneyMode();

    $scope.updateOpenReturn = function(isOpenReturn) {
        $scope.params.isOpenReturn = isOpenReturn;
    };

    const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.RailTicketSearchSegments[0]._date);
    const initialReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.RailTicketSearchSegments[1]._date);

    function performDomesticSearch() {
        const intSearchType = Number($stateParams.FlightType === 'roundtrip');
        railsFactory.getAllPreviousSearches(intSearchType)
            .then(({data}) => {
                $scope.previousSearches = data;
                $scope.SearchedRecord = $scope.previousSearches.filter((rec) => rec.SearchId === $stateParams.DomesticSearchGUId);
                const search = $scope.SearchedRecord;
                $scope.options = railsFactory.options;
                repeatDomesticSearch(search[0], $stateParams.FlightType, $scope.options);
            });
    }

    $scope.optionsDepart = {
        placeholder: l10nService.localize('Date'),
        required: true,
        months: 2,
        start: initialDepartDate,
        after: timeService.getUkTime().startOf('day').add({days: -1}),
        before: railsFactory.getMaxBookDate(),
        dependentPikers: ['optionsReturn'],
    };

    //Return date
    $scope.optionsReturn = {
        placeholder: l10nService.localize('Date'),
        required: true,
        months: 2,
        start: initialReturnDate,
        after: moment(initialDepartDate).add({days: -1}),
        before: railsFactory.getMaxBookDate(),
    };

    $scope.optionsReturnValidate = function(ctrl) { // eslint-disable-line
        if (angular.isUndefined($scope.params.RailTicketSearchSegments[0].DHour) || angular.isUndefined($scope.params.RailTicketSearchSegments[0].DMinutes)) {
            return false;
        }
        const departDate = Date.parse(moment($scope.params.RailTicketSearchSegments[0]._date, 'DD/MM/YYYY'));
        const departHours = $scope.params.RailTicketSearchSegments[0].DHour.Value;
        const departMinutes = $scope.params.RailTicketSearchSegments[0].DMinutes.Value;
        const returnDate = Date.parse(moment($scope.params.RailTicketSearchSegments[1]._date, 'DD/MM/YYYY'));

        if (angular.isDefined(ctrl.railsSearch.date1)) {
            ctrl.railsSearch.$valid = true;
            ctrl.railsSearch.date1.$error.dateMin = false;
            ctrl.railsSearch.RoundTripReturnHour.$error.invalidHour = false;
            ctrl.railsSearch.RoundTripReturnMinutes.$error.invalidMinute = false;
            ctrl.railsSearch.RoundTripReturnHour.$setValidity('invalidHour', true);
            ctrl.railsSearch.RoundTripReturnMinutes.$setValidity('invalidMinute', true);
            if (returnDate < departDate) {
                ctrl.railsSearch.date1.$error.dateMin = true;
                ctrl.railsSearch.$valid = false;
                return false;
            } else if (returnDate === departDate) {
                if (parseInt($scope.params.RailTicketSearchSegments[1].RHour.Value, 10) < departHours) {
                    ctrl.railsSearch.RoundTripReturnHour.$error.invalidHour = true;
                    ctrl.railsSearch.RoundTripReturnHour.$setValidity('invalidHour', false);
                    ctrl.railsSearch.$valid = false;
                    return false;
                } else if (parseInt($scope.params.RailTicketSearchSegments[1].RHour.Value, 10) === departHours
                    && parseInt($scope.params.RailTicketSearchSegments[1].RMinutes.Value, 10) <= departMinutes) {
                    ctrl.railsSearch.RoundTripReturnMinutes.$error.invalidMinute = true;
                    ctrl.railsSearch.RoundTripReturnMinutes.$setValidity('invalidMinute', false);
                    ctrl.railsSearch.$valid = false;
                    return false;
                }
            }
            return true;
        }
    };

    $scope.findRails = findRails;
    $scope.repeatSearch = repeatSearch;

    previousSearches.fetchTop();

    $scope.$watch('params.RailTicketSearchSegments[0]._date', departDateWatcher);
    $scope.$watch('params.RailTicketSearchSegments[1]._date', returnTimeWatcher);
    $scope.$watch('params.RailTicketSearchSegments[0]._time', returnTimeWatcher, true);
    $scope.$watch('params.RailTicketSearchSegments[0]._date',
        railsUtils.refreshReturnedDate.bind($scope.params.RailTicketSearchSegments)
    );

    $scope.$watch('params.isOpenReturn', setJourneyMode);

    $scope.$watch('params.RailTicketSearchSegments[0]._departure', stationsWatcher);
    $scope.$watch('params.RailTicketSearchSegments[0]._arrival', stationsWatcher);

    $scope.start = 1;
    $scope.end = 3;
    $scope.count = '';
    $scope.Flag = true;

    $scope.disableOpenReturn = false;

    function stationsWatcher() {
        if ($scope.params.RailTicketSearchSegments[0]._departure && $scope.params.RailTicketSearchSegments[0]._departure.Code.startsWith('urn:')
            || $scope.params.RailTicketSearchSegments[0]._arrival && $scope.params.RailTicketSearchSegments[0]._arrival.Code.startsWith('urn:')) {
            $scope.params.isOpenReturn = false;
            $scope.disableOpenReturn = true;
        } else {
            $scope.disableOpenReturn = false;
        }
    }

    function departDateWatcher() {
        if (!$scope.params.isOpenReturn) {
            if ($scope.params.RailTicketSearchSegments[0]._date > $scope.params.RailTicketSearchSegments[1]._date) {
                $scope.params.RailTicketSearchSegments[1]._date = $scope.params.RailTicketSearchSegments[0]._date;
            }
        }
    }

    function setJourneyMode() {
        if ($scope.params.isOpenReturn) {
            $scope.params.ReturnOrSingleJourney = 'O';
        } else {
            $scope.params.ReturnOrSingleJourney = 'R';
        }
    }

    function findRails() {
        $scope.params.flightType = 'roundtrip';
        const preparedParams = false;
        railsFactory.fetchRails(angular.copy($scope.params), preparedParams,
            {
                outbound: $scope.params.RailTicketSearchSegments[0]._isArrivalTime,
                inbound: $scope.params.RailTicketSearchSegments[1]._isArrivalTime,
            })
            .then((data) => $state.go(data.EuropeanRails ? railStates.EUROPEANRESULTS : railStates.RESULTS));
    }

    function allPreviousResultsShown() {
        return $scope.maxPreviousSearches === railsFactory.ALL_PREV_SEARCHES_LIMIT;
    }

    function repeatDomesticSearch(search, type, options) {
        // set open state of 'more options' panel
        $scope.showOptions = railsUtils.moreOptionsApplied(search);

        railsFactory.getSearch(search.Id)
            .then(({data}) => {
                data.RailTicketSearchSegments.forEach((segment, i) => {
                    segment.IsDepartureCity = search.SearchSegments[i].IsDeparturePointCity;
                    segment.IsArrivalCity = search.SearchSegments[i].IsArrivalPointCity;
                    segment.IsGoViaAOrAvoidStation = search.SearchSegments[i].IsGoViaAOrAvoidPointCity;
                });

                $scope.updateArrival(0, data.RailTicketSearchSegments[0].DayTimeFilterSource);
                if (data.ReturnOrSingleJourney === 'R') {
                    $scope.updateArrival(1, data.RailTicketSearchSegments[1].DayTimeFilterSource);
                }

                $scope.params.isOpenReturn = data.IsOpenReturn;

                railsFactory.params.recreate(search, data, options, type);
                return railsFactory.getRailSearchByGuid($stateParams.DomesticSearchGUId, true);
            })
            .then(() => {
                if ($stateParams !== null) {
                    const {DomesticSearchGUId, FlightType} = $stateParams;
                    $state.go(railStates.RESULTS, {DomesticSearchGUId, FlightType});
                } else {
                    $state.go(railStates.RESULTS);
                }
            });
    }

    function repeatSearch(search, type, options) {
        // set open state of 'more options' panel
        $scope.showOptions = railsUtils.moreOptionsApplied(search);

        railsFactory.getSearch(search.Id)
            .then(function(res) {
                angular.forEach(res.data.RailTicketSearchSegments, function(segment, i) {
                    segment.IsDepartureCity = search.SearchSegments[i].IsDeparturePointCity;
                    segment.IsArrivalCity = search.SearchSegments[i].IsArrivalPointCity;
                    segment.IsGoViaAOrAvoidStation = search.SearchSegments[i].IsGoViaAOrAvoidPointCity;
                });

                $scope.updateArrival(0, res.data.RailTicketSearchSegments[0].DayTimeFilterSource);
                if (res.data.ReturnOrSingleJourney === 'R') {
                    $scope.updateArrival(1, res.data.RailTicketSearchSegments[1].DayTimeFilterSource);
                }

                $scope.params.isOpenReturn = res.data.IsOpenReturn;

                railsFactory.params.recreate(search, res.data, options, type);
                return railsFactory.fetchRails(res.data, true);
            })
            .then(function(data) {
                if ($stateParams !== null) {
                    const domesticGUID = $stateParams.DomesticSearchGUId;
                    const flightType = $stateParams.FlightType;
                    $state.go(data.EuropeanRails ? railStates.EUROPEANRESULTS : railStates.RESULTS, {DomesticSearchGUId: domesticGUID, FlightType: flightType});
                } else {
                    $state.go(data.EuropeanRails ? railStates.EUROPEANRESULTS : railStates.RESULTS);
                }
            });
    }

    function getPreviousSearchObject() {
        let allSearchesFetched = false;

        return {
            fetchTop: function() {
                railsFactory.getTopPreviousSearches(1).then(function(response) {
                    $scope.previousSearches = response.data;
                });
            },

            fetchAll: function() {
                if (allSearchesFetched) {
                    return;
                }

                railsFactory.getAllPreviousSearches(1).then(function(response) {
                    $scope.previousSearches = response.data;
                    allSearchesFetched = true;
                });
            },
        };
    }

    function togglePreviousSearches() {
        previousSearches.fetchAll();
        $scope.maxPreviousSearches = $scope.allPreviousResultsShown()
            ? railsFactory.TOP_PREV_SEARCHES_LIMIT
            : railsFactory.ALL_PREV_SEARCHES_LIMIT;
    }

    function returnTimeWatcher() {
        if (!$scope.params.isOpenReturn) {
            railsUtils.returnTimeWatcher(
                $scope.params.RailTicketSearchSegments[0]._date,
                $scope.params.RailTicketSearchSegments[1]._date,
                $scope.options.time1,
                $scope.params.RailTicketSearchSegments[0]._time,
                $scope.params.RailTicketSearchSegments[1]._time,
                $scope.options.time
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/ukrail/railRoundtripBaseCtrl.js